import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "WhatsApp for Healthcare: Your New Digital Receptionist",
    listHeading: "Are missed calls, no-shows, and front-desk chaos costing your healthcare business money? You'll learn how to:",
    listText: [
        { label: "Automate appointment scheduling and confirmations" },
        { label: "Handle common patient queries without human staff" },
        { label: "Deliver post-consultation care instructions, prescriptions, and feedback requests" },
        { label: "Improve response rates with WhatsApp vs SMS or phone" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-4.png",
    speakerList: [
        {
            image: "/vidhya.png",
            name: "Vidhya S",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    youtubeURL: "https://youtu.be/-zWGvSkdE_A",
    inThisWebinar: "You'll learn how to:",
    webinarSlug: "whatsapp-healthcare",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="Make WhatsApp work for Healthcare companies - Gallabox webinars"
            description="See how clinics use WhatsApp to book, remind, and manage patients — on autopilot. Access the webinar now"
            canonical="https://gallabox.com/webinars/whatsapp-healthcare"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-4.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
